import MediaFilesUploader from './MediaFilesUploader';

export default MediaFilesUploader;
